module.exports = __webpack_public_path__ + "media/PAG84-04.b05c39a9.mp3";